import type { CSSProperties } from "react";
import type { BackgroundStyle } from "@/cms/appearance";
import {
  backgroundGradient,
  fadeGradient,
  responsiveVariables,
} from "@/utils/visual-style";

export default function SectionBackground({
  image,
  background,
}: {
  image: string;
  background: BackgroundStyle;
}) {
  return (
    <div aria-hidden="true" className="re-background">
      {image && (
        <div
          className="re-background-photo"
          style={
            {
              "--re-photo": `url(${JSON.stringify(background.mobileImage || image)})`,
              "--re-photo-desktop": `url(${JSON.stringify(image)})`,
              ...responsiveVariables(
                "photo-position",
                background.position,
                "center",
              ),
            } as CSSProperties
          }
        />
      )}
      {background.overlayColor && (
        <div style={{ backgroundColor: background.overlayColor }} />
      )}
      {background.gradient && (
        <div
          style={{ backgroundImage: backgroundGradient(background.gradient) }}
        />
      )}
      {background.fade && (
        <div style={{ backgroundImage: fadeGradient(background.fade) }} />
      )}
    </div>
  );
}
